/**
 * @generated SignedSource<<1fd12b23830104f4be80f27548a027a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type feedbackQuote_CustomerFeedbackQueryFragment$data = {
  readonly customerData: {
    readonly amountCustomer: string;
    readonly customerFeedbacks: ReadonlyArray<{
      readonly feedback: string;
      readonly id: string;
      readonly name: string;
      readonly position: string;
    }>;
  };
  readonly " $fragmentType": "feedbackQuote_CustomerFeedbackQueryFragment";
};
export type feedbackQuote_CustomerFeedbackQueryFragment$key = {
  readonly " $data"?: feedbackQuote_CustomerFeedbackQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"feedbackQuote_CustomerFeedbackQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "feedbackQuote_CustomerFeedbackQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerData",
      "kind": "LinkedField",
      "name": "customerData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountCustomer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomerFeedback",
          "kind": "LinkedField",
          "name": "customerFeedbacks",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "feedback",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Trend",
  "abstractKey": null
};

(node as any).hash = "9a6f23b1f685063ee01ef35e16618834";

export default node;
